module.exports = __webpack_public_path__ + "img/unified-menu.a2935096.svg";